"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var generic_1 = require("./generic");
var collection_1 = require("./collection");
var modal_1 = require("./modal");
var route_1 = require("./route");
var ui_1 = require("./ui");
var index_1 = require("./security/index");
var index_2 = require("./account/index");
var emails_1 = require("./emails");
var preferences_1 = require("./preferences");
var reducers = {
    generic: generic_1.default,
    collection: collection_1.default,
    modal: modal_1.default,
    route: route_1.default,
    ui: ui_1.default,
    emails: emails_1.default,
    security: index_1.default,
    account: index_2.default,
    preferences: preferences_1.default
};
exports.default = reducers;
